import { KpiEconomy } from "@app/shared/classes/kpi-economy";
import { Utilities } from "@app/shared/utils/utilities";
import siteConfig from "@app/site-config";

export class KpiHelper {
  static GenerateEconomyValueWithUom(kpiEconomy: KpiEconomy) {
    if (!kpiEconomy || kpiEconomy.kpiValue === null || kpiEconomy.kpiValue === undefined) {
      return "";
    }

    var uom = this.FormatKpiUom(kpiEconomy.kpiUom);
    var value = kpiEconomy.kpiValue;
    if (uom === "%") {
      value = value * 100;
    }

    return value.toFixed(2) + uom;
  }

  private static FormatKpiUom(uom: string) {
    if (Utilities.isEmptyString(uom)) {
      return '';
    }

    if (siteConfig.HiddenKpiUomValue.includes(uom)) {
      return '';
    }

    return uom;
  }
}
